<template>
  <v-dialog v-model="isSelectedStore" scrollable max-width="500px" persistent>
    <v-card>
      <v-card-title>Selecione um produtor</v-card-title>
      <v-text-field
        placeholder="Pesquisar produtor"
        class="px-6"
        append-icon="mdi-magnify"
        v-model="research"
        autofocus
      ></v-text-field>
      <v-divider></v-divider>
      <v-card-text style="height: 300px">
        <template v-if="storeLoading">
          <v-skeleton-loader
            type="list-item-avatar"
            class="my-1"
            v-for="n in 5"
            :key="n"
          ></v-skeleton-loader>
        </template>
        <template v-else>
          <v-list-item
            v-for="store in storeListFiltered"
            :key="store.idloja"
            @click="setStore(store)"
          >
            <v-list-item-avatar>
              <v-img
                :alt="`${store.nome_loja}`"
                :src="store.tema_logotipo"
              ></v-img>
            </v-list-item-avatar>
            <v-list-item-title>{{ store.nome_loja }}</v-list-item-title>
          </v-list-item>
        </template>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  name: "StoreSelector",
  data() {
    return {
      isSelectedStore: false,
      research: "",
    };
  },
  computed: {
    ...mapGetters([
      "storeSelector",
      "storeList",
      "storeLoading",
      "isAdmin",
      "storeSequencial",
    ]),
    storeListFiltered() {
      return this.storeList.filter(store =>
        store.nome_loja
          .toString()
          .toLocaleLowerCase()
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "")
          .includes(
            this.research
              .toString()
              .toLocaleLowerCase()
              .normalize("NFD")
              .replace(/[\u0300-\u036f]/g, "")
          )
      );
    },
  },
  watch: {
    "$store.getters.storeSequencial"() {
      if (this.isAdmin && this.storeSequencial) {
        this.isSelectedStore = false;
      }
    },
  },
  mounted() {
    if (this.isAdmin && this.storeSequencial === undefined) {
      this.isSelectedStore = true;
      this.setStoreSelector();
    }
  },
  methods: {
    ...mapActions(["setStoreSelector", "setStore"]),
  },
};
</script>
